export const css = {
    root: '_1bc-9sHv',
    vertical: '_1aKCs9kK',
    horizontal: '_3F7KxWuI',
    step: '_3VT6IoIQ',
    tail: '_39OJgn2c',
    complete: 'esX69Jf-',
    clickable: '_9DFlgBcU',
    stepIcon: '_3OJIEF9A',
    stepContent: '_2-iVsCnC',
    stepDescription: 'Scw2xD6y',
    stepTitle: '_2FYuKm5z',
    noDescription: 'lNzsfsqZ',
    noTitle: '_20vFcHsu',
    pending: '_2y6jg0BJ',
    stepSubTitle: '_2Mzwc_NY',
    completed: '_3feUICzy',
    avatarRoot: '_2nR1OcMO _3Pvmypil',
    error: '_20g5x7FA',
    ' _key': 'certwise-theme/dojo/wizard'
};
export default css;
